import React, { useState, useEffect } from 'react';
import './AddServer.css';
import Navbar from '../Navbar/Navbar';
import ApiClient from '../../api/apiClient';
import { useTheme } from '../ThemeContext'; 
import { FaServer, FaGlobe } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';

const AddServer = () => {
  const { servers: cachedServers, environments: cachedEnvs, refreshServers, refreshEnvironments } = useData();
  const [newServerName, setNewServerName] = useState('');
  const [newServerLink, setNewServerLink] = useState('');
  const [servers, setServers] = useState([]);
  const [envs, setEnvs] = useState([]);
  const [selectedEnv, setSelectedEnv] = useState('');
  const [log, setLog] = useState([]);
  const [error, setError] = useState(null);
  const { theme } = useTheme();  // Get the current theme
  const { user } = useAuth();


  const handleAddServer = async (e) => {
    e.preventDefault();

    // Debugging logs
    console.log('Server Name:', newServerName);
    console.log('Server Link:', newServerLink);
    console.log('Selected Environment:', selectedEnv);

    if (!newServerName.trim() || !newServerLink.trim() || !selectedEnv) {
      setError('Please fill in all fields');
      return;
    }
    if (!newServerLink.startsWith('https://')) {
      setError('Server link must start with https://');
      return;
    }

    const serverData = { name: newServerName, link: newServerLink, env: selectedEnv, organization: user?.organization || 'default' };

    try {
      const response = await ApiClient.post('/api/servers/add-server', serverData);
      setServers([...servers, response.data.server]);
      await refreshServers();
      await refreshEnvironments();
      setNewServerName('');
      setNewServerLink('');
      setSelectedEnv('');
      setLog([...log, `Server added successfully: ${newServerName} || ${newServerLink}`]);
      setError(null);
    } catch (error) {
      setLog([...log, `Error adding server: ${error.message}`]);
      setError('Error adding server');
    }
  };

  const handleClearLog = () => {
    setLog([]);
  };

  useEffect(() => {
    setServers(cachedServers || []);
  }, [cachedServers]);

  useEffect(() => {
    if (Array.isArray(cachedEnvs)) {
      setEnvs(cachedEnvs);
    } else {
      setEnvs([]);
    }
  }, [cachedEnvs]);

  return (
    <div className={`Configuration-container ${theme}`}>
      <Navbar />
      <div className="Configuration-content page-transition">
        <div className="page-shell">
        <header className="config-header">
          <div>
            <p className="eyebrow">Configuration</p>
            <h1 className="page-title">Configure your fleet</h1>
            <p className="config-subtitle">Add servers and map them to the right environment.</p>
          </div>
          <div className="config-stats">
            <div className="stat-tile">
              <FaServer /> <span>{servers.length} Servers</span>
            </div>
            <div className="stat-tile">
              <FaGlobe /> <span>{envs.length} Environments</span>
            </div>
          </div>
        </header>

        <div className="config-grid">
          <div className="config-card form-card">
            <div className="card-header">
              <div>
                <p className="eyebrow">New entry</p>
                <h2>Add a server</h2>
              </div>
            </div>
            <form onSubmit={handleAddServer} className="config-form">
              <label>
                Server Name
                <input
                  placeholder="Enter your server name"
                  type="text"
                  value={newServerName}
                  onChange={(e) => setNewServerName(e.target.value)}
                  required
                />
              </label>
              <label>
                Server Link
                <input
                  placeholder="https://example.com"
                  type="text"
                  value={newServerLink}
                  onChange={(e) => setNewServerLink(e.target.value)}
                  required
                  pattern="https://.*"
                />
              </label>
              <label>
                Environment
                <select
                  value={selectedEnv}
                  onChange={(e) => setSelectedEnv(e.target.value)}
                  required
                >
                  <option value="" disabled>Select environment</option>
                  {envs.map((env) => (
                    <option key={env._id} value={env._id}>{env.name}</option>
                  ))}
                </select>
              </label>
              {error && <div className="notification error">{error}</div>}
              <div className="form-actions">
                <button className="add-button2" type="submit">+ Add Server</button>
              </div>
            </form>
          </div>

          <div className="config-card log-card">
            <div className="card-header">
              <div>
                <p className="eyebrow">Activity</p>
                <h2>Log</h2>
              </div>
              <button className="clear-button" onClick={handleClearLog}>Clear</button>
            </div>
            <div className="log-terminal">
              <ul>
                {log.map((message, index) => (
                  <li key={index}>{message}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default AddServer;
